<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [dismissableMask]="true"
  styleClass="how-it-works-modal-v2"
  [style]="{ width: '95vw', maxWidth: '1000px', height: 'auto', maxHeight: '90vh' }"
  (onHide)="closeModal()">

  <!-- Header Minimalista -->
  <ng-template pTemplate="header">
    <div class="flex align-items-center gap-3">
      <div class="icon-box flex align-items-center justify-content-center flex-shrink-0 border-round-lg text-white">
        <i class="pi pi-lightbulb"></i>
      </div>
      <div class="header-text">
        <h2 class="m-0">Como Funciona</h2>
        <p class="m-0">Guia rápido para o seu sucesso</p>
      </div>
    </div>
  </ng-template>

  <div class="layout-container">
    <!-- Sidebar (Lista de Passos) -->
    <aside class="sidebar">
      <div class="flex flex-column gap-2">
        @for (step of steps; track step.number; let i = $index) {
          <div
            class="step-item flex align-items-center gap-3 border-round-lg cursor-pointer"
            [class.active]="currentStep() === i"
            [class.completed]="currentStep() > i"
            role="button"
            tabindex="0"
            (click)="goToStep(i)"
            (keydown.enter)="goToStep(i)"
            (keydown.space)="goToStep(i)"
            pRipple>
            <div class="step-indicator flex align-items-center justify-content-center flex-shrink-0 border-circle">
              @if (currentStep() > i) {
                <i class="pi pi-check"></i>
              } @else {
                <span>{{ step.number }}</span>
              }
            </div>
            <div class="step-info flex flex-column">
              <span class="step-title">{{ step.title }}</span>
              <span class="step-time">{{ getStepDuration(step.number) }}</span>
            </div>
          </div>
        }
      </div>
    </aside>

    <!-- Conteúdo Principal -->
    <main class="main-content relative flex flex-column h-full overflow-y-auto p-4 md:p-5">
      <!-- Barra de progresso (só aparece em mobile) -->
      <div class="mobile-progress mb-4">
        <div class="mobile-step-info flex justify-content-between mb-2">
          <span>Passo {{ currentStep() + 1 }} de {{ steps.length }}</span>
          <strong>{{ steps[currentStep()].title }}</strong>
        </div>
        <p-progressbar
          [value]="progressPercent()"
          [showValue]="false"
          styleClass="modal-progress" />
      </div>

      <!-- Área do Conteúdo Dinâmico -->
      <div class="step-detail-container">
        @for (step of steps; track step.number; let stepIndex = $index) {
          @if (currentStep() === stepIndex) {
            <div class="step-detail-view fade-in flex flex-column flex-1 gap-4 md:gap-5">

              <!-- Título do Passo -->
              <div class="detail-header flex flex-column md:flex-row align-items-center md:align-items-start text-center md:text-left gap-3 md:gap-4">
                <div class="big-icon flex align-items-center justify-content-center flex-shrink-0 text-white" [style.background]="step.gradient">
                  <i class="pi {{ step.icon }}"></i>
                </div>
                <div class="title-group">
                  <h3 class="mt-0 mb-2">{{ step.title }}</h3>
                  <p class="m-0">{{ step.description }}</p>
                </div>
              </div>

              <!-- Colunas de Informação -->
              <div class="flex flex-column md:flex-row gap-3 md:gap-4">
                <!-- Coluna Ações -->
                <div class="info-card action-card flex-1 border-round-xl p-3">
                  <div class="card-title flex align-items-center gap-2 mb-3">
                    <i class="pi pi-list-check"></i>
                    <span>O que você fará</span>
                  </div>
                  <ul class="check-list list-none p-0 m-0 flex flex-column">
                    @for (detail of getStepDetails(step.number); track $index) {
                      <li class="flex align-items-start">
                        <i class="pi pi-check-circle"></i>
                        <span>{{ detail }}</span>
                      </li>
                    }
                  </ul>
                </div>

                <!-- Coluna Benefícios -->
                <div class="info-card benefit-card flex-1 border-round-xl p-3">
                  <div class="card-title flex align-items-center gap-2 mb-3">
                    <i class="pi pi-star"></i>
                    <span>Benefícios</span>
                  </div>
                  <ul class="benefit-list list-none p-0 m-0 flex flex-column">
                    @for (benefit of getStepBenefits(step.number); track $index) {
                      <li class="flex align-items-start">
                        <i class="pi pi-bolt"></i>
                        <span>{{ benefit }}</span>
                      </li>
                    }
                  </ul>
                </div>
              </div>

            </div>
          }
        }
      </div>

      <!-- Footer de Features (Estático no fundo do main) -->
      <div class="features-footer mt-auto pt-4">
        @for (feature of features; track feature.title) {
          <div class="feature-mini-item flex align-items-center gap-2">
            <i class="pi {{ feature.icon }}"></i>
            <span>{{ feature.title }}</span>
          </div>
        }
      </div>
    </main>
  </div>

  <!-- Footer da Modal (Navegação) -->
  <ng-template pTemplate="footer">
    <div class="flex justify-content-between align-items-center w-full">
      <button
        pButton
        class="p-button-text p-button-secondary"
        icon="pi pi-arrow-left"
        label="Voltar"
        (click)="previousStep()"
        [disabled]="isFirstStep">
      </button>

      <div class="flex align-items-center gap-3">
        <button
          pButton
          class="p-button-text p-button-plain hide-mobile"
          label="Pular Tutorial"
          (click)="closeModal()">
        </button>

        @if (!isLastStep) {
          <button
            pButton
            icon="pi pi-arrow-right"
            iconPos="right"
            label="Próximo Passo"
            (click)="nextStep()"
            [style]="{ 'background': steps[currentStep()].gradient, 'border': 'none' }">
          </button>
        } @else {
          <button
            pButton
            class="p-button-success"
            icon="pi pi-check"
            label="Começar Agora"
            (click)="startNow()">
          </button>
        }
      </div>
    </div>
  </ng-template>
</p-dialog>
